// export const host = `${window.location.origin}/api`
// export const host = 'http://119.23.74.199:9112/xinqing_clinic'
// export const host = 'http://zentao.zhaoyang120.cn'
export const host = 'https://api.xinqingclinic.com'



// WEBPACK FOOTER //
// ./src/config/config.js